import prepareComponent from "@bluframe/grapple/prepareComponent";
import useActionsCheckbox from "hooks/actions/useActionsCheckbox";
import useListButton from "hooks/actions/useListButton";
import Actions from "./Actions";
const usePrepareComponent = ({ serviceName }) => {
    const onlyNewProps = useActionsCheckbox({
        inputId: `${serviceName}-isOnlyNew`,
        label: "Only New",
        serviceName,
        serviceType: "news",
        setValueName: "setIsOnlyNew",
        valueName: "isOnlyNew"
    });
    const listButtonProps = useListButton({
        serviceName,
        serviceType: "news"
    });
    return {
        listButtonProps,
        onlyNewProps,
        serviceName
    };
};
export default prepareComponent(usePrepareComponent)(Actions);
